module.exports = __webpack_public_path__ + "img/Villa_Borna_67.78bb38dd.jpg";